// extracted by mini-css-extract-plugin
module.exports = {"base":"TextColumnsWithLinks_base__K9n09","colWrap":"TextColumnsWithLinks_colWrap__C6QUF","textCol":"TextColumnsWithLinks_textCol__0rhq2"};